import React, { useContext, useEffect } from 'react';
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Divider, useDisclosure } from '@chakra-ui/react';
import { IosShareIcon } from './icons/iosShare';
import { VerticalEllipsisIcon } from './icons/verticalEllipsis';
import { isMobile } from 'mobile-device-detect';
import { getPlatformType } from '../../utils/helpers';
import { PwaInstallPrompt } from '../../App';

export const PwaInstallModal = (openModal) => {

    const PwaInstallPromptContext = useContext(PwaInstallPrompt);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const installPwa = () => {
        onClose()
        if (PwaInstallPromptContext) {
            PwaInstallPromptContext.prompt();
        }
    }

    useEffect(() => {
        if (openModal) {
            onOpen()
        }
    }, []);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size={isMobile ? 'xs' : 'xl'} >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h1>Install Progressive Web App</h1>
                        <img src="/favicon-32x32.png" alt="" style={{ objectFit: 'contain' }} />
                    </div>
                </ModalHeader>
                <Divider />
                <ModalBody>
                    <p style={{ marginBottom: '25px', display: isMobile ? 'none' : 'block' }}>Dive into the depths of the Alaskan oceans with our Progressive Web App (PWA)! Install now to unlock an unparalleled experience and take full advantage of the Alaska Ocean Observing System.</p>
                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Instant Ocean Insights: </span>Access live ocean data, weather, and marine forecasts instantly.</p>
                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Stay Connected Anywhere: </span>Our PWA keeps you informed, even when you're offline or in low-network areas.</p>
                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Automatic Updates: </span>Enjoy the latest ocean information without lifting a finger.</p>
                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Pocket-Sized AOOS: </span>Add to your home screen for one-tap access, carrying AOOS with you.</p>
                </ModalBody>
                <Divider />
                <ModalFooter justifyContent={getPlatformType() === 'native' ? 'flex-end' : 'space-between'}>
                    {getPlatformType() === 'native' &&
                        <>
                            <Button variant='ghost' mr={3} onClick={onClose}>Close</Button>
                            <Button colorScheme='teal' onClick={installPwa}>Install</Button>
                        </>
                    }
                    {getPlatformType() === 'iOS' &&
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                            <p>To Install This App:</p>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <p>Tap the share button</p>
                                <IosShareIcon />
                            </div>
                            <p>Tap "Add to Home Screen"</p>
                        </div>
                    }
                    {getPlatformType() === 'android' &&
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                            <p>To Install This App:</p>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <p>Tap the settings button</p>
                                <VerticalEllipsisIcon />
                            </div>
                            <p>Tap "Add to Home Screen"</p>
                        </div>
                    }
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}